import { createFileRoute } from "@tanstack/react-router";
import { DashboardShell, PlaceholderCard } from "@/components/DashboardShell";
import { SUPER_ADMIN_NAV } from "@/lib/nav";

export const Route = createFileRoute("/_authenticated/super-admin/properties")({
  head: () => ({
    meta: [
      { title: "Property management · Landoo Super Admin" },
      { name: "description", content: "Property management — Landoo super admin console." },
    ],
  }),
  component: () => (
    <DashboardShell title="Property management" role="Super Admin" items={SUPER_ADMIN_NAV}>
      <PlaceholderCard
        title="Property management"
        description="Super admin management surface for Property management."
      />
    </DashboardShell>
  ),
});
